var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheck = function SvgIconCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 923",
    style: {
      enableBackground: "new 0 0 1200 923"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1081.3 0c-30 1-58.4 13.7-79.2 35.3-220.7 221.2-389.3 406-594.2 615L189.7 466c-23.4-19.8-53.7-29.4-84.2-26.8-30.5 2.6-58.8 17.2-78.5 40.6C7.3 503.3-2.2 533.6.4 564.1c2.7 30.5 17.4 58.7 40.9 78.3L340.9 896c22.1 18.6 50.2 28.2 79 27 28.8-1.2 56.1-13.1 76.5-33.5 248.2-248.7 424.9-447.4 668.4-691.4 22.4-21.7 35.1-51.5 35.2-82.7 0-31.2-12.6-61.1-34.9-82.8-22.4-21.7-52.6-33.5-83.8-32.6z",
    fill: "currentColor"
  })));
};
export default SvgIconCheck;